module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index
    }, [(item.path) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.handleClick(item.path)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b8ee36a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/BreadCrumb/BreadCrumb.vue
// module id = 841
// module chunks = 11